import css from 'styled-jsx/css';

const styles = css.global`@font-face {
  font-family: 'SantanderHeadline';
  src: url('static/amp/shared/fonts/SantanderHeadline-Regular.otf');
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'SantanderMicroText';
  src: url('static/amp/shared/fonts/SantanderMicroTextLt.woff') format('woff'),
    url('static/amp/shared/fonts/SantanderMicroTextLt.otf') format('otf');
  font-weight: 300;
  font-display: swap;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'SantanderMicroText';
  src: url('static/amp/shared/fonts/SantanderMicroText.ttf');
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}



@font-face {
  font-family: 'SantanderMicroText';
  src: url('static/amp/shared/fonts/SantanderMicroText.woff2') format('woff2'),
    url('static/amp/shared/fonts/SantanderMicroText.woff') format('woff');
  font-weight: 500;
  font-display: swap;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'SantanderMicroText';
  src: url('static/amp/shared/fonts/SantanderMicroTextBd.ttf');
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'SantanderText-Light';
  src: url('static/amp/shared/fonts/SantanderText-Light.woff2') format('woff2'),
    url('static/amp/shared/fonts/SantanderText-Light.woff') format('woff');
  font-weight: 300;
  font-display: swap;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'SantanderText';
  src: url('static/amp/shared/fonts/SantanderText-Regular.ttf');
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'SantanderText';
  src: url('static/amp/shared/fonts/SantanderText-Bold.ttf');
  font-weight: 600;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'SantanderText';
  src: url('static/amp/shared/fonts/SantanderText-Bold.ttf');
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'SantanderText';
  src: url('static/amp/shared/fonts/SantanderTextIt.woff') format("woff");
  font-weight: 400;
  font-style: italic;
  font-display: swap;
}

@font-face {
  font-family: 'SantanderHeadline';
  src: url('static/amp/shared/fonts/SantanderHeadline-Regular.otf');
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'SantanderHeadline';
  src: url('static/amp/shared/fonts/SantanderHeadline-Bold.otf');
  font-weight: 800;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'SantanderHeadlineIt';
  src: url('static/amp/shared/fonts/SantanderHeadline-It.otf');
  font-weight: 500;
  font-style: italic;
  font-display: swap;
}
@font-face {
  font-family: 'SantanderHeadlineIt';
  src: url('static/amp/shared/fonts/SantanderHeadline-BoldIt.otf');
  font-weight: 800;
  font-style: italic;
  font-display: swap;
}
@font-face {
  font-family: 'SantanderCondensed';
  src: url('static/amp/shared/fonts/SantanderCondensed-Regular.otf');
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'SantanderCondensed';
  src: url('static/amp/shared/fonts/SantanderCondensed-Bold.otf');
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}

@font-face{
  font-family:'SantanderIcons';
  src:url('static/amp/shared/fonts/SantanderIcons.woff') format("woff"),url('static/amp/shared/fonts/SantanderIcons.woff2') format("woff2")
}
/* 
* {
  font-family: 'Open Sans', sans-serif;
} */

`;

export default styles;